<form-checkbox
	(checkedChange)="handleCheckChange($event)"
	[checked]="selected"
	[disabled]="disabled"
></form-checkbox>
